// extracted by mini-css-extract-plugin
export default {"info":"UserInfo_info__Qh5WJ","info__row":"UserInfo_info__row__4yFY6","info__tariff":"UserInfo_info__tariff__x31OD","info__field-title":"UserInfo_info__field-title__EVFRl"};